import { defineStore } from 'pinia'

import { useReportCardStore } from './reportCard';
import { useModalityStore } from './modality';


function courseHasModuleType (course, type) {
    return course?.moduleTypes?.includes(type);
}

function getPointsByType (course, type) {
    if (!courseHasModuleType(course, type)) return undefined;

    const $reportCardStore = useReportCardStore();
    const reportCard       = $reportCardStore.getCourseCard(course.id);

    if (!reportCard?.separatedMark) return undefined;
    if (!(type in reportCard.separatedMark)) return undefined;

    return reportCard.separatedMark[type] || 0;
}


export const useCourseNavbarPanelStore = defineStore({
    id: 'courseNavbar',

    state () {
        return {
            state: 'default',
            tab:   'program',

            course: {},
            modules: [],

            providers: {},
            initialProviders: {},
            messages: {},

            telegramBotEnabled: false,
            telegramBotUsername: 'CasesMediaBot',
            telegramInfo: {},
        };
    },

    getters: {
        states () {
            return [
                'default',
                'points',
                'telegram',
            ];
        },

        tabs () {
            return [
                'program',
                'archive',
                'notifications',
                'watch-mode',
            ];
        },

        messageKeys () {
            return [
                'course_release',
                'course_module_release',
                'course_practice',
                'course_cooldown',
            ];
        },


        pointsTheory (state) {
            return getPointsByType(state.course, 'theory');
        },

        pointsPractice (state) {
            return getPointsByType(state.course, 'practice');
        },

        pointsCreativity (state) {
            return getPointsByType(state.course, 'creativity');
        },
    },

    actions: {
        setState (state) {
            if (this.state == state) return;
            if (!this.states.includes(state)) return;

            this.state = state;
        },

        setTab (tab) {
            if (this.tab == tab) return;
            if (!this.tabs.includes(tab)) return;

            this.tab = tab;
        },


        reset () {
            this.state = 'default';
            this.tab   = 'program';
        },

        close () {
            const $modalityStore = useModalityStore();

            $modalityStore.closeModal({ type: 'drawer' });
            this.reset();
        },


        courseHasModuleType (type) {
            return courseHasModuleType(this.course, type);
        },
    },
});